module.exports = __webpack_public_path__ + "img/faceberry_master.49736865.png";